

import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Content } from '../components/content';
import { AuthContext } from '../auth-context';
import { LoginForm } from '../components/forms/login-form';
import { RoutePaths } from '../route-paths';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import LOGO from "../assets/labour_logo_white.svg";

export class SignIn extends React.Component<RouteComponentProps<any>, any> {
    constructor(props: RouteComponentProps<any>) {
        super(props);
        this.state = {};
    }
    private onLoginSuccess = () => {
        this.props.history.push(RoutePaths.Home);
    }

    private onReset = () => {
        this.props.history.push(RoutePaths.ResetPassword);
    }
    render() {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);

        let initialLoadContent: JSX.Element;
        if (this.state.initialLoad) {
            if (params.get('confirmed')) {
                initialLoadContent = <div className="alert alert-success" role="alert">
                    Your email address has been successfully confirmed.
                    </div>
            }

            if (params.get('expired')) {
                initialLoadContent = <div className="alert alert-info" role="alert">
                    <strong>Sesion Expired</strong> You need to sign in again.
                    </div>
            }

            if (this.props.history.location.state && this.props.history.location.state.signedOut) {
                initialLoadContent = <div className="alert alert-info" role="alert">
                    <strong>Signed Out</strong>
                </div>
            }
        }

        return <>
            <AuthContext.Consumer>
                {({ methods: { initLogin } }) => {
                    const redirectToHomeLoginAction = (username: string, password: string, onError: (err: any) => void) => initLogin(username, password, onError, this.onLoginSuccess);
                    return <>
                        <AppBar position="static" color="primary">
                            <Toolbar>
                                <div><img style={{height: '50px', marginLeft:'-20px' }} className="app-logo-nzl-fern" src={LOGO} /></div>
                            </Toolbar>
                        </AppBar>
                        <Content>
                            {initialLoadContent}
                            <LoginForm loginAction={redirectToHomeLoginAction} resetAction={this.onReset} />
                        </Content>
                    </>;
                }}
            </AuthContext.Consumer>
        </>;
    }
}


// WEBPACK FOOTER //
// ./src/pages/sign-in-page.tsx